import stores from 'cd-eft/models/Stores';
import { action, observable } from 'mobx';
import { slopeCalc } from '../../../business/EFH2/slopeCalc';

export interface ISlopeCalcProps {
  callback: (value: number) => void;
  close: () => void;
  hidden: boolean;
}

export class SlopeCalcVM {
  props: ISlopeCalcProps;
  constructor(props: ISlopeCalcProps) {
    this.props = props;
  }

  @observable slopeCalcInput = {
    contourLength: 0,
    contourInterval: 0,
    drainArea: 0,
  };

  @observable slope = this.slopeCalculation();

  @action.bound slopeCalculation() {
    return slopeCalc(
      this.slopeCalcInput.contourLength,
      this.slopeCalcInput.contourInterval,
      this.slopeCalcInput.drainArea
    );
  }

  @action.bound getDrainageArea() {
    if (stores.AppStore.efh2Store.basicDataForm.drainageArea) {
      this.slopeCalcInput.drainArea = stores.AppStore.efh2Store.basicDataForm.drainageArea;
    }
    this.slope = this.slopeCalculation();
  }

  @action.bound sendToBasicData(event: any) {
    event.preventDefault();
    this.props.callback(this.slope);
  }

  @action.bound handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.slopeCalcInput[name] = value;
    this.validateField(name, value);
    this.slope = this.slopeCalculation();
  }

  @observable formValidation = {
    formErrors: {
      contourLength: '',
      contourInterval: '',
      drainArea: '',
    },
    contourLengthValid: true,
    contourIntervalValid: true,
    drainAreaValid: true,
    formValid: true,
  };

  // validation by field
  @action.bound validateField(fieldName: string, value: number) {
    // connects form field to validation table
    const keyValid = fieldName + 'Valid';
    let fieldValid = this.formValidation[keyValid];
    const fieldValidationErrors = this.formValidation.formErrors;

    switch (fieldName) {
      case 'contourLength':
      case 'contourInterval':
      case 'drainArea':
        fieldValid = value > 0;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be greater than 0';
        break;
      default:
        break;
    }
    this.formValidation.formErrors = fieldValidationErrors;
    this.formValidation[keyValid] = fieldValid;
    this.validateForm();
  }

  // checks if there are any error msgs over entire form
  @action.bound validateForm() {
    let valid = true;
    for (const key in this.formValidation.formErrors) {
      if (!this.formValidation[key + 'Valid']) {
        valid = false;
      }
    }
    this.formValidation.formValid = valid;
  }

  @action.bound errorClass(field: string) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage.length === 0 ? '' : ' usa-input--error';
  }
}
